import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
    getQuotation, getSolution, getMaterialPrice, setQuotation
} from 'services/redux/sales/projectOnboarding/action';
import EditQuotation from './editQuotation';

const mapStateToProps = (state) => ({
  quotation: state.projectOnboardingReducer.quotation,
  solution: state.projectOnboardingReducer.solution
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getQuotation,
      getSolution, 
      getMaterialPrice, 
      setQuotation
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(EditQuotation);
